import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, CheckCircle2Icon, Trash2Icon } from 'lucide-react';
import { Reveal } from '../components/Reveal';
import { useCart } from '../CartContext';
import { useContent } from '../ContentContext';
export function Checkout() {
  const {
    items,
    removeFromCart,
    totalItems,
    clearCart
  } = useCart();
  const {
    addRequest
  } = useContent();
  const [step, setStep] = useState(1);
  const [type, setType] = useState<'private' | 'company'>('company');
  const [logistics, setLogistics] = useState<'pickup' | 'delivery'>('delivery');
  const [form, setForm] = useState({
    name: '',
    email: '',
    date: '',
    guests: '',
    notes: ''
  });
  const setField = (key: keyof typeof form, value: string) => setForm(prev => ({
    ...prev,
    [key]: value
  }));
  const submitRequest = () => {
    addRequest({
      id: `req-${Date.now()}`,
      createdAt: new Date().toISOString(),
      customerType: type,
      logistics,
      ...form,
      items: items.map(i => ({
        name: i.name,
        businessName: i.businessName,
        quantity: i.quantity,
        price: i.price
      })),
      total: items.reduce((sum, i) => sum + i.price * i.quantity, 0),
      status: 'ny'
    });
    clearCart();
    setStep(3);
  };
  if (step === 3) {
    return <div className="flex min-h-screen items-center justify-center pt-20" data-id="element-381" data-mp="hv7z76u2d2ow">
        <Reveal className="text-center" data-id="element-382" data-mp="3geor327piqi2">
          <CheckCircle2Icon className="mx-auto h-16 w-16 text-skog" data-id="element-383" data-mp="3gfzqyqy17e3w" />
          <h1 className="mt-6 font-display text-4xl text-brun" data-id="element-384" data-mp="3leb1z502bunp">Förfrågan skickad</h1>
          <p className="mt-4 text-brun-soft" data-id="element-385" data-mp="3qbt9qs2cg3u4">Vi återkommer till dig inom kort med en bekräftelse.</p>
        </Reveal>
      </div>;
  }
  const cartTotal = items.reduce((sum, item) => sum + item.price * item.quantity, 0);
  return <div className="min-h-screen bg-gray-50 pt-32 pb-24" data-id="element-386" data-mp="15lke51nq7zoz">
      <div className="mx-auto max-w-6xl px-6 md:px-10" data-id="element-387" data-mp="19n5y16yohe8o">
        <Reveal data-id="element-388" data-mp="19ps5l6lkjtqw">
          <h1 className="font-display text-4xl font-medium text-gray-900 md:text-5xl" data-id="element-389" data-mp="36obi0oiubs6r">Gör en förfrågan</h1>
          
          <div className="mt-12 flex items-center gap-4 border-b border-gray-200 pb-8" data-id="element-390" data-mp="31prvon0c4edv">
            <div className={`flex h-8 w-8 items-center justify-center rounded-full text-sm font-medium transition-colors ${step >= 1 ? 'bg-black text-white' : 'bg-gray-200 text-gray-500'}`} data-id="element-391" data-mp="3forlvz3hx1c5">1</div>
            <div className={`h-px w-12 transition-colors ${step >= 2 ? 'bg-black' : 'bg-gray-200'}`} data-id="element-392" data-mp="2n02synclg2bh" />
            <div className={`flex h-8 w-8 items-center justify-center rounded-full text-sm font-medium transition-colors ${step >= 2 ? 'bg-black text-white' : 'bg-gray-200 text-gray-500'}`} data-id="element-393" data-mp="2iz0s62313i7e">2</div>
          </div>
        </Reveal>

        <div className="mt-12 grid gap-12 lg:grid-cols-[1fr,400px]" data-id="element-394" data-mp="2rye18tn8q4rl">
          <div data-id="element-395" data-mp="249l3crn25muc">
            {step === 1 && <Reveal delay={0.1} className="space-y-10" data-id="element-396" data-mp="248a0cu1fsj4a">
                <section data-id="element-397" data-mp="1zbb8ki58wo99">
                  <h2 className="text-lg font-bold text-gray-900" data-id="element-398" data-mp="1za022akf12eg">Kundtyp</h2>
                  <div className="mt-4 grid grid-cols-2 gap-4" data-id="element-399" data-mp="esh4czysztpb">
                    <button onClick={() => setType('company')} className={`rounded-2xl border-2 p-6 text-left transition-all ${type === 'company' ? 'border-black bg-gray-50' : 'border-gray-100 hover:border-gray-200'}`} data-id="element-400" data-mp="eqwdbkbp6sw7">
                      <p className="font-bold text-gray-900" data-id="element-401" data-mp="aqm5e24chsep">Företag</p>
                      <p className="mt-1 text-sm text-gray-500" data-id="element-402" data-mp="aoriii9ijq7z">Event, konferens, kontorsfika</p>
                    </button>
                    <button onClick={() => setType('private')} className={`rounded-2xl border-2 p-6 text-left transition-all ${type === 'private' ? 'border-black bg-gray-50' : 'border-gray-100 hover:border-gray-200'}`} data-id="element-403" data-mp="12i1srydq7j5z">
                      <p className="font-bold text-gray-900" data-id="element-404" data-mp="tgkbwdshvdg8">Privat</p>
                      <p className="mt-1 text-sm text-gray-500" data-id="element-405" data-mp="399168jkkuj4i">Bröllop, fest, middag</p>
                    </button>
                  </div>
                </section>

                <section data-id="element-406" data-mp="3e5rkr2gqh6nt">
                  <h2 className="text-lg font-bold text-gray-900" data-id="element-407" data-mp="3thhkaawxdewh">Leveranssätt</h2>
                  <div className="mt-4 grid grid-cols-2 gap-4" data-id="element-408" data-mp="3tjc4fn0dh2zi">
                    <button onClick={() => setLogistics('delivery')} className={`rounded-2xl border-2 p-6 text-left transition-all ${logistics === 'delivery' ? 'border-black bg-gray-50' : 'border-gray-100 hover:border-gray-200'}`} data-id="element-409" data-mp="3opzixlqzpcaz">
                      <p className="font-bold text-gray-900" data-id="element-410" data-mp="3fo9oe71t9x8z">Leverans</p>
                      <p className="mt-1 text-sm text-gray-500" data-id="element-411" data-mp="gafssvlm8a05">Vi kör ut till er</p>
                    </button>
                    <button onClick={() => setLogistics('pickup')} className={`rounded-2xl border-2 p-6 text-left transition-all ${logistics === 'pickup' ? 'border-black bg-gray-50' : 'border-gray-100 hover:border-gray-200'}`} data-id="element-412" data-mp="c79nbq6bumuq">
                      <p className="font-bold text-gray-900" data-id="element-413" data-mp="2s08m3fv87d20">Upphämtning</p>
                      <p className="mt-1 text-sm text-gray-500" data-id="element-414" data-mp="2ryfdvw4yskrw">Hämta själv hos aktören</p>
                    </button>
                  </div>
                </section>

                <button onClick={() => setStep(2)} className="flex w-full items-center justify-center gap-2 rounded-full bg-black py-4 text-base font-medium text-white transition-transform hover:scale-[1.02]" data-id="element-415" data-mp="2cytci51zvr0j">
                  Gå vidare
                  <ArrowRightIcon className="h-5 w-5" data-id="element-416" data-mp="2mttox6b9ft95" />
                </button>
              </Reveal>}

            {step === 2 && <Reveal delay={0.1} className="space-y-8" data-id="element-417" data-mp="2vmyep83073x8">
                <div className="grid gap-6 md:grid-cols-2" data-id="element-418" data-mp="30n2vz0bqk2oi">
                  <div data-id="element-419" data-mp="30li1tbtc2lr6">
                    <label className="mb-2 block text-xs font-bold uppercase tracking-wider text-gray-500" data-id="element-420" data-mp="30ow4kl5wswz5">Namn / Företag</label>
                    <input type="text" value={form.name} onChange={e => setField('name', e.target.value)} className="w-full rounded-xl border border-gray-200 bg-white p-4 text-gray-900 outline-none transition-colors focus:border-black" placeholder="Namn" data-id="element-421" data-mp="3alsf0wfdbt6c" />
                  </div>
                  <div data-id="element-422" data-mp="186jvgt5t1dwn">
                    <label className="mb-2 block text-xs font-bold uppercase tracking-wider text-gray-500" data-id="element-423" data-mp="185qj9co2tw74">E-post</label>
                    <input type="email" value={form.email} onChange={e => setField('email', e.target.value)} className="w-full rounded-xl border border-gray-200 bg-white p-4 text-gray-900 outline-none transition-colors focus:border-black" placeholder="E-postadress" data-id="element-424" data-mp="138qohxwogfvb" />
                  </div>
                  <div data-id="element-425" data-mp="1r4cnh0ew43f9">
                    <label className="mb-2 block text-xs font-bold uppercase tracking-wider text-gray-500" data-id="element-426" data-mp="1r3l1mhb3hk26">Datum för event</label>
                    <input type="date" value={form.date} onChange={e => setField('date', e.target.value)} className="w-full rounded-xl border border-gray-200 bg-white p-4 text-gray-900 outline-none transition-colors focus:border-black" data-id="element-427" data-mp="20v7jgwhxuhdw" />
                  </div>
                  <div data-id="element-428" data-mp="29wf3c9jpjfog">
                    <label className="mb-2 block text-xs font-bold uppercase tracking-wider text-gray-500" data-id="element-429" data-mp="29tj7cqrf712n">Antal gäster (ca)</label>
                    <input type="number" value={form.guests} onChange={e => setField('guests', e.target.value)} className="w-full rounded-xl border border-gray-200 bg-white p-4 text-gray-900 outline-none transition-colors focus:border-black" placeholder="T.ex. 50" data-id="element-430" data-mp="2oi2u4dkf1iga" />
                  </div>
                </div>
                
                <div data-id="element-431" data-mp="2kfo6zh9prwj7">
                  <label className="mb-2 block text-xs font-bold uppercase tracking-wider text-gray-500" data-id="element-432" data-mp="2kj3pyv6idppw">Beskriv era önskemål</label>
                  <textarea rows={4} value={form.notes} onChange={e => setField('notes', e.target.value)} className="w-full rounded-xl border border-gray-200 bg-white p-4 text-gray-900 outline-none transition-colors focus:border-black" placeholder="Allergier, specifika önskemål..." data-id="element-433" data-mp="2aijlzkrlu73z" />
                </div>

                <div className="flex gap-4" data-id="element-434" data-mp="1mspab6j0uolb">
                  <button onClick={() => setStep(1)} className="rounded-full border border-gray-200 bg-white px-8 py-4 text-base font-medium text-gray-900 transition-colors hover:bg-gray-50" data-id="element-435" data-mp="1mu0nfwycx8p3">
                    Tillbaka
                  </button>
                  <button onClick={submitRequest} className="flex flex-1 items-center justify-center gap-2 rounded-full bg-black px-8 py-4 text-base font-medium text-white transition-transform hover:scale-[1.02]" data-id="element-436" data-mp="22aqkx0l6ckh7">
                    Skicka förfrågan
                    <ArrowRightIcon className="h-5 w-5" data-id="element-437" data-mp="1taaky13n3vh3" />
                  </button>
                </div>
              </Reveal>}
          </div>

          {/* Premium Cart Summary Sidebar (Stripe style) */}
          <aside data-id="element-438" data-mp="1jixrj5270x8y">
            <Reveal delay={0.2} data-id="element-439" data-mp="1eledo69eqmhj">
              <div className="sticky top-32 rounded-3xl bg-white p-8 shadow-premium" data-id="element-440" data-mp="1empebx7k3e4f">
                <h2 className="font-display text-2xl font-medium text-gray-900" data-id="element-441" data-mp="1akvlgb3lreet">Din varukorg</h2>
                <p className="mt-1 text-sm text-gray-500" data-id="element-442" data-mp="15l97fzfy9u4y">{totalItems} {totalItems === 1 ? 'produkt' : 'produkter'}</p>
                
                <div className="mt-8 divide-y divide-gray-100 border-t border-gray-100" data-id="element-443" data-mp="10mogkqml8mt6">
                  {items.length === 0 ? <div className="py-12 text-center" data-id="element-444" data-mp="3h8cnr4kxwctl">
                      <p className="text-gray-500" data-id="element-445" data-mp="3h6rv5ki6r3yd">Din varukorg är tom.</p>
                      <Link to="/utbud" className="mt-4 inline-block rounded-full bg-gray-100 px-6 py-2 text-sm font-medium text-gray-900 hover:bg-gray-200" data-id="element-446" data-mp="3m8h6z2d8flni">Gå till utbudet</Link>
                    </div> : <>
                      {items.map(item => <div key={item.id} className="flex items-center gap-4 py-4" data-id="element-447" data-mp="2yiwmgf1fkgc4">
                          <img src={item.image} alt={item.name} className="h-14 w-14 rounded-xl object-cover" data-id="element-448" data-mp="32ix386c053mc" />
                          <div className="flex-1" data-id="element-449" data-mp="37b6xtzo2aruy">
                            <p className="text-sm font-bold text-gray-900" data-id="element-450" data-mp="37bzxyhsimj44">{item.name}</p>
                            <p className="text-[10px] uppercase tracking-wider text-gray-400" data-id="element-451" data-mp="2aq6bo959k33f">{item.businessName}</p>
                          </div>
                          <div className="flex flex-col items-end gap-1" data-id="element-452" data-mp="268gd9anbo79f">
                            <span className="text-sm font-medium text-gray-900" data-id="element-453" data-mp="2b6hx3xskoaly">{item.price * item.quantity} kr</span>
                            <div className="flex items-center gap-3" data-id="element-454" data-mp="2f7tni5j9szv7">
                              <span className="text-xs text-gray-500" data-id="element-455" data-mp="2k7g32lmkms76">x{item.quantity}</span>
                              <button onClick={() => removeFromCart(item.id)} className="text-gray-400 hover:text-red-500 transition-colors" data-id="element-456" data-mp="2k5296g3mnm17">
                                <Trash2Icon className="h-4 w-4" data-id="element-457" data-mp="1rhzbtraothcj" />
                              </button>
                            </div>
                          </div>
                        </div>)}
                      <div className="flex items-center justify-between pt-6 mt-2" data-id="element-458" data-mp="21a54l38rk2ss">
                        <span className="text-base font-medium text-gray-900" data-id="element-459" data-mp="13s55lskvir19">Totalt (exkl. moms)</span>
                        <span className="text-xl font-bold text-gray-900" data-id="element-460" data-mp="18qyh5fglo7ys">{cartTotal} kr</span>
                      </div>
                    </>}
                </div>
              </div>
            </Reveal>
          </aside>
        </div>
      </div>
    </div>;
}